import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import ManagerTgNotifyContent from './ManagerTgNotifyContent';

export default function ManagerTgNotify() {
  return (
    <CasinoContainer title={'Notifications for managers on Telegram'}>
      <ManagerTgNotifyContent />
    </CasinoContainer>
  );
}
